import {createUseStyles} from "react-jss";
import {buttons, colors, label, space} from "../../theme";

const baseButton = {
    fontWeight: "normal",
    textTransform: "uppercase",
    fontSize: "0.8em",
}

export const useStyles = createUseStyles({
    component: {

    },
    label: {
      ...label,
    },
    options: {
        display: "flex",
        gap: space(),
    },
    button: {
        ...buttons.secondary,
        ...baseButton,
        "--on-button-color": colors.neutral90,
        "--button-color": "white",
        border: "1px solid "+colors.primary,
        boxSizing: "border-box",
    },
    selected: {
        ...buttons.primary,
        ...baseButton,
        border: "1px solid "+colors.primary,
    }
});